export * from './post-rolle.component';
export * from './post-rolle.component.module';